import { ICON_NAMES } from '@reverse-hr/design-system';
import type {
  TIconName,
  TSkillsSliderVariant,
} from '@reverse-hr/design-system';

export const HINT_ICONS_BY_VARIANT: Partial<
  Record<TSkillsSliderVariant, TIconName>
> = {
  success: ICON_NAMES.CHECK,
  warning: ICON_NAMES.WARNING_OUTLINE,
};
